'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseDetails', ['$scope', '$uibModal', '$window', 'Licenses', '$state', 'LicenseCharges', '$q', 'LicenseRules', 'Users', 'ProcessLicenses', 'Resource', function ($scope, $uibModal, $window, Licenses, $state, LicenseCharges, $q, LicenseRules, Users, ProcessLicenses, Resource) {
        $scope.resetLicense();
        $scope.isDetailsOpen = true;
        $scope.isPublicApplicationOpen = true;
        $scope.isTrainingVerificationOpen = true;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.copying = false;
        $scope.viewClauses = false;
        $scope.months = Resource.months();
        $scope.birthdate_duration = Resource.birthdate_duration();
        $scope.messages = [];
        $scope.licenseID = $state.params.id;

        $scope.save = function () {
            $scope.messages = [];
            if ($scope.license.date_type_id && $scope.license.date_value == null) {
                $scope.messages.push("Please enter a number for the license duration");
                $window.scrollTo(0, 0);
            } else if (!$scope.license.date_type_id && $scope.license.date_value != null) {
                $scope.messages.push("Please enter a type for the license duration");
                $window.scrollTo(0, 0);
            } else {
                $scope.saving = true;
                Licenses.save($scope.license).then(function(license) {
                    $scope.saving = false;
                    $scope.setMasterLicense(license);
                    if (license != null && $scope.licenseID == null) {
                        $state.go('internal.licensing.license.details.details', { id: license.id, license: license });
                    }
                });
            } 
        }

        $scope.delete = function () {
            $scope.deleting = true;

            if (window.confirm('Are you sure you want to delete this license?')) {
                Licenses.delete($scope.licenseID).then(function () {
                    $scope.deleting = false;
                    $state.go('internal.licensing.licenses');
                })
            }
            else {
                $scope.deleting = false;
            }
        }

        $scope.copy = function () {
            $scope.copying = true;
            var copiedLicense = angular.copy($scope.license);
            copiedLicense.id = undefined;
            copiedLicense.name = 'Copy of ' + $scope.license.name;

            Licenses.save(copiedLicense).then(function (license) {
                var all = [];

                $scope.license.license_charges.forEach(function (charge) {
                    var copiedCharge = angular.copy(charge);
                    copiedCharge.id = undefined;
                    copiedCharge.license_id = license.id;
                    copiedCharge.modified_license_charge_conditions = charge.license_charge_conditions;
                    all.push(LicenseCharges.save(copiedCharge).then(function (license_charge) {
                        updateArray(license.license_charges, license_charge);
                    }))
                })

                $scope.license.process_licenses.forEach(function (processLicense) {
                    var copiedProcessLicense = angular.copy(processLicense);
                    copiedProcessLicense.id = undefined;
                    copiedProcessLicense.license_id = license.id;
                    all.push(ProcessLicenses.save(copiedProcessLicense).then(function (process_license) {
                        updateArray(license.process_licenses, process_license);
                    }))
                })

                $q.all(all).then(function () {
                    $scope.copying = false;
                    if (license != null) {
                        $state.go('internal.licensing.license.details.details', { id: license.id, license: license });
                    }
                }).catch(function (response) {
                    // handle error
                });
            })
        }

        $scope.openCategoryModal = function () {
            $scope.categoryRefresh = true;
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: paths.app + 'licenses/components/license-category-modal/license-category-modal.html',
                controller: 'InternalLicenseCategoryModal',
                size: 'lg'
            });

            modalInstance.result.catch(function () {
                $scope.categoryRefresh = false;
            });
            
            modalInstance.result.then(function (license_category) {
                $scope.license.license_category_id = license_category.id;
                $scope.categoryRefresh = false;
            });
        }

        $scope.openConfigurationModal = function () {
            $scope.configurationRefresh = true;
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: paths.app + 'licenses/components/trigger-configuration-modal/trigger-configuration-modal.html',
                controller: 'InternalTriggerConfigurationModal',
                size: 'lg'
            });

            modalInstance.result.catch(function () {
                $scope.configurationRefresh = false;
            });

            modalInstance.result.then(function (trigger_configuration) {
                $scope.configurationRefresh = false;
                $scope.license.trigger_configuration_id = trigger_configuration.id;
            });
        }

        $scope.showClauses = function (viewClauses, licenseRules) {
            $scope.viewClauses = !viewClauses;
            
            if ($scope.viewClauses) {
                if (licenseRules != null && licenseRules.length > 0) {
                    $scope.ruleLoading = true;
                    var args = LicenseRules.build(licenseRules);
                    $scope.clauses = args.clauses;
                    $scope.numOfClauses = args.numOfClauses;

                    Users.query(licenseRules.map(function (licenseRule) { return licenseRule.id })).then(function (users) {
                       args.columns.unshift({
                            label: 'Qualified Personnel',
                            field: 'full_name'
                        });
                        $scope.ruleUsers = users;

                        //Get only distinct columns
                        var seenColumns = {};
                        $scope.ruleColumns = args.columns.filter(function (column) {
                            if (seenColumns[column.field]) {
                                return false;
                            }
                            // Mark this field as seen
                            seenColumns[column.field] = true;
                            return true;
                        });
                        $scope.ruleLoading = false;
                    });
                    $scope.ruleLoading = false;
                }
                else {
                    $scope.ruleUsers = [];
                    $scope.clauses = '';
                    $scope.numOfClauses = 3;
                }
            }
        }
    }])
;